<div class="browse-guide-container">
  <app-guide [guide]="guide|async"
             [selectedMapMarker]="selectedMapMarker$|async">
  </app-guide>
  <app-loading
    [hidden]="!loadingOpts.isLoading"
    [options]="(loadingOpts)">
  </app-loading>
</div>
